// extracted by mini-css-extract-plugin
export default {"backArrowBtn":"back-arrow-button_backArrowBtn__M26nH"};